import '../../../../Proell.ErrorMonitoring/Resources/Private/JavaScript/ErrorMonitoring'
